//@flow
import { HiverAxios, SET_WELCOME_DONE } from 'h-commons';

export const welcomeDone = () => (dispatch: Function) => {
    HiverAxios({
        url: '/gx/api/freshiframeseen',
        type: 'POST',
        callback: () => {
            dispatch({
                type: SET_WELCOME_DONE
            });
        }
    })
}